module.exports = __webpack_public_path__ + "img/stock7.92fe7b46.png";